'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jsxRuntime = require('react/jsx-runtime');
var classNames = require('classnames');
var PropTypes = require('prop-types');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function Grid(_ref) {
  var _classNames;

  var align = _ref.align,
      children = _ref.children,
      className = _ref.className,
      fixedColumnWidth = _ref.fixedColumnWidth,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      otherProps = _objectWithoutProperties(_ref, ["align", "children", "className", "fixedColumnWidth", "tag"]);

  var classes = classNames__default['default']('mdc-layout-grid', className, (_classNames = {}, _defineProperty(_classNames, "mdc-layout-grid--align-".concat(align), align), _defineProperty(_classNames, 'mdc-layout-grid--fixed-column-width', fixedColumnWidth), _classNames));
  return /*#__PURE__*/jsxRuntime.jsx(Tag, _objectSpread2(_objectSpread2({
    className: classes
  }, otherProps), {}, {
    children: children
  }));
}
Grid.displayName = 'Grid';
Grid.propTypes = {
  align: PropTypes__default['default'].oneOf(['left', 'right']),
  children: PropTypes__default['default'].node,
  className: PropTypes__default['default'].string,
  fixedColumnWidth: PropTypes__default['default'].bool,
  tag: PropTypes__default['default'].oneOfType([PropTypes__default['default'].object, PropTypes__default['default'].string])
};
function GridRow(_ref2) {
  var children = _ref2.children,
      className = _ref2.className,
      _ref2$tag = _ref2.tag,
      Tag = _ref2$tag === void 0 ? 'div' : _ref2$tag,
      otherProps = _objectWithoutProperties(_ref2, ["children", "className", "tag"]);

  var classes = classNames__default['default']('mdc-layout-grid__inner', className);
  return /*#__PURE__*/jsxRuntime.jsx(Tag, _objectSpread2(_objectSpread2({
    className: classes
  }, otherProps), {}, {
    children: children
  }));
}
GridRow.displayName = 'GridRow';
GridRow.propTypes = {
  children: PropTypes__default['default'].node,
  className: PropTypes__default['default'].string,
  tag: PropTypes__default['default'].oneOfType([PropTypes__default['default'].object, PropTypes__default['default'].string])
};
function GridCell(_ref3) {
  var _classNames2;

  var align = _ref3.align,
      children = _ref3.children,
      className = _ref3.className,
      order = _ref3.order,
      span = _ref3.span,
      spanDesktop = _ref3.spanDesktop,
      spanPhone = _ref3.spanPhone,
      spanTablet = _ref3.spanTablet,
      _ref3$tag = _ref3.tag,
      Tag = _ref3$tag === void 0 ? 'div' : _ref3$tag,
      otherProps = _objectWithoutProperties(_ref3, ["align", "children", "className", "order", "span", "spanDesktop", "spanPhone", "spanTablet", "tag"]);

  var classes = classNames__default['default']('mdc-layout-grid__cell', className, (_classNames2 = {}, _defineProperty(_classNames2, "mdc-layout-grid__cell--align-".concat(align), align), _defineProperty(_classNames2, "mdc-layout-grid__cell--order-".concat(order), order), _defineProperty(_classNames2, "mdc-layout-grid__cell--span-".concat(span), span), _defineProperty(_classNames2, "mdc-layout-grid__cell--span-".concat(spanDesktop, "-desktop"), spanDesktop), _defineProperty(_classNames2, "mdc-layout-grid__cell--span-".concat(spanPhone, "-phone"), spanPhone), _defineProperty(_classNames2, "mdc-layout-grid__cell--span-".concat(spanTablet, "-tablet"), spanTablet), _classNames2));
  return /*#__PURE__*/jsxRuntime.jsx(Tag, _objectSpread2(_objectSpread2({
    className: classes
  }, otherProps), {}, {
    children: children
  }));
}
var INTEGERS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
GridCell.displayName = 'GridCell';
GridCell.propTypes = {
  align: PropTypes__default['default'].oneOf(['top', 'middle', 'bottom']),
  children: PropTypes__default['default'].node,
  className: PropTypes__default['default'].string,
  order: PropTypes__default['default'].oneOf(INTEGERS),
  span: PropTypes__default['default'].oneOf(INTEGERS),
  spanDesktop: PropTypes__default['default'].oneOf(INTEGERS),
  spanPhone: PropTypes__default['default'].oneOf(INTEGERS),
  spanTablet: PropTypes__default['default'].oneOf(INTEGERS),
  tag: PropTypes__default['default'].oneOfType([PropTypes__default['default'].object, PropTypes__default['default'].string])
};

exports.Grid = Grid;
exports.GridCell = GridCell;
exports.GridRow = GridRow;
